import { useEffect } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from 'technical/db';
import { useSyncData } from 'business/scan-site-settings/hooks/use-sync-data';
import { useNetworkStatus } from 'technical/network/use-network-status';
import { getLocalStorageValue } from 'technical/local-storage';
import { PENDING_UPLOAD_TIMESTAMP_KEY } from 'technical/local-storage/constants';

export const useAutoSync = () => {
  const { isOnline } = useNetworkStatus();
  const { upload, isUploading } = useSyncData();

  const unsyncedCount = useLiveQuery(
    () => db.segments.filter((s) => s.desynchronizedAt !== null).count(),
    [],
  );

  useEffect(() => {
    const hasPendingUpload =
      getLocalStorageValue({ key: PENDING_UPLOAD_TIMESTAMP_KEY }) !== null;

    if (
      isOnline &&
      !isUploading &&
      unsyncedCount !== undefined &&
      unsyncedCount > 0 &&
      !hasPendingUpload
    ) {
      upload();
    }
  }, [isOnline, isUploading, unsyncedCount, upload]);
};
